import { fetchEmail, fetchUserEmail } from "../services/GenericAPI";
import { Globals } from "../global/Globals";
import {getProducerByProducerID} from '../services/SystemAdminAPI';
import CryptoUtils from "./cryptoUtils";
/**
 * Function to extract video ID from the youtube link
 * @param {string} url
 * @returns string
 */
export function getYoutubeVideoId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
}

/**
 * Function to set cookies with expiry time in minutes
 * @param {string} cookieName
 * @param {string} cookieValue
 * @param {number} expiryMinutes
 */
export function setCookies(cookieName, cookieValue, expiryMinutes = 60) {
  const date = new Date();
  date.setTime(date.getTime() + expiryMinutes * 60 * 1000);
  CryptoUtils.saveToLocalStorage(cookieName, cookieValue);
  document.cookie = `${cookieName}=${cookieValue}; expires=${date.toUTCString()}; path=/;`;
   CryptoUtils.saveToLocalStorage('isCookieAvailable',true);
}

/**
* Function to get the value of a specific cookie by name
* @param {string} name - The name of the cookie to retrieve
* @returns {string|null} - The value of the cookie if found, otherwise null
*/
export function getCookie(name) {
  const cookieName = name + "=";
  const cookieList = document.cookie.split(";");
  for (let i = 0; i < cookieList.length; i++) {
    let cookie = cookieList[i];
    while (cookie.charAt(0) === " ") cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(cookieName) === 0) return cookie.substring(cookieName.length, cookie.length);
  }
  return null;
}

/**
* Function to delete a specific cookie by name
* @param {string} cookieName - The name of the cookie to delete
*/
export function deleteCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1850 00:00:00 UTC; path=/`;
}
export const formatDate = (dateString) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  const DateOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  return date.toLocaleDateString("en-GB", DateOptions);
};

export function validatePhoneNumber(phoneNumber) {
  return Globals.REGEX.PHONE_NUMBER_REGEX.test(phoneNumber);
}

export function validateEmail(email) {
  return Globals.REGEX.EMAIL_REGEX.test(email)
}

export function checkEmailExistance(email) {
  fetchEmail(email)
    .then((response) => {
      return response.data.exists; // ? setIsEmailExist(true) : setIsEmailExist(false);
    })
    .catch((error) => {
      console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
    });
}

export function checkUserEmailExistance(email,setValidMail,setErrorMessage) {
  fetchUserEmail(email)
    .then((response) => {
      if(response.data.exists){
        setValidMail(false);
        setErrorMessage(Globals.ERROR_MESSAGES.EMAIL_EXIST);
      }else{
        setValidMail(true);
      }
    })
    .catch((error) => {
      setValidMail(true);
      console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
      return;
    });
}

export function validateName(name) {
  return Globals.REGEX.NAME_REGEX.test(name);
}

export function validateWebsite(website) {
  return Globals.REGEX.WEBSITE_REGEX.test(website);
}

export function validateSocialMediaLinks(smLink) {
  return Globals.REGEX.SOCIAL_MEDIA_LINKS_REGEX.test(smLink);
}

export function dateFunct(inp) {
  const date = new Date(inp);

  const options = {
    hour: "2-digit",
    minute: "2-digit",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour12: false,
  };

        const formattedDate = date.toLocaleString('en-GB', options).split(', ');

        return `${formattedDate[0]}`;
}
export function validatePassword(password) {
        return Globals.REGEX.ACTIVATION_PASSWORD_REGEX.test(password);
}

export function validatescore(value, maxvalue) {
  const regex = /^\d+(\.\d{0,2})?$/;
  if (/^0{2,}/.test(value)) {
    value = value.replace(/^0{2,}/, "0");
  }
  if (
    value === "" ||
    (Number(value) <= maxvalue && Number(value) >= 0 && regex.test(value))
  ) {
    return true;
  } else {
    return false;
  }
}

export function fileUploader(fileName){
  const fileFormData=new FormData();
  fileFormData.append("file",fileName);
}

export function  getProducerRecord(){
  const producerID=CryptoUtils.getFromLocalStorage('pKey');
  getProducerByProducerID(producerID).then((response) => {
        if (response?.content) {
          const respData = response?.content;
          const languagesList = respData?.languages.map(language => language.languageName);
          const channelsList = respData?.channels.map(channel => channel.channelName);
          const formatsList = respData?.formats.map(_formats => _formats.formatName);
          const genresList = respData?.genres.map(genre => genre.genreName);
          const productioTypesList = respData?.productionTypes?.map(prodType => prodType.productionTypeName);
          const producerRecord = {
            companyName: respData?.producer?.companyName,
            companyRegNo: respData?.producer?.companyRegNo,
            title: respData?.producer?.title,
            vatRegistrationNumber: respData?.producer?.vatRegistrationNumber,
            vendorRegistrationNumber: respData?.producer?.vendorRegistrationNumber,
            isTaxClearanceCertificate: respData?.producer?.isTaxClearanceCertificate,
            isBBBEE: respData?.producer?.isBBBEE,
            companyContactNumber: respData?.producer?.companyContactNumber,
            businessAddress: respData?.producer?.businessAddress,
            companyEmail: respData?.producer?.companyEmail,
            language: languagesList.join(','),
            genre: genresList?.join(','),
            channels: channelsList?.join(','),
            formats: formatsList?.join(','),
            productionTypes: productioTypesList?.join(','),
            website: respData?.producer?.website,
            socialMediaLinks: respData?.producer?.socialMediaLinks,
            country: respData?.producer?.countryName,
            provience: respData?.producer?.provinceName,
            email: respData?.producer?.email,
            name: respData?.producer?.name,
            isVendorRegistered: respData?.producer?.isVendorRegistered,
            logofile: respData?.producer?.logofile
          };
          return producerRecord;
         // dispatch(setProducerDetails({ producerDetails: producerRecord }));
        }
        else {
          console.error("No producer records found");
          return null;
        }
      }).catch((error) => {
        console.error("Error in getting producer details : ", error);
      })
}

export function formatRoleName(rolename){
  const roleName = typeof rolename === 'string'
  ? rolename.toUpperCase().replace(/[- ]/g, '')
  : '';
  const shortFormName= Globals[roleName];
  return shortFormName;
}

export function formatclusterandroleName(name,type){
  const ClusterRoleName = name ? name?.replace(/[-&\s]/g, '').toUpperCase() : "";
  const finalname = type === "Cluster" ? ClusterRoleName :  ClusterRoleName;
  return finalname;
}

export const getFieldKeys = (obj,value) => {
    const trimmedValue = typeof value === 'string' ? value.trim() : value;
    return Object.keys(obj).find(key => {
      const objValue = obj[key];
      return typeof objValue === 'string' ? objValue.trim() === trimmedValue : objValue === trimmedValue;
    });
  }

export const swapObject = (obj) => {
  const swappedObject = {};
  // Loop through each key-value pair in the original object
  for (const key in obj) {
    // Ensure the property belongs to the object itself, not its prototype chain
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      // Assign the value as the new key and the key as the new value
      swappedObject[value] = key;
    }
  }
  return swappedObject;
}

export const formatCurrency = (amount) => {
  if (amount === "" || isNaN(amount)) return amount;
  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return numberFormatter.format(Number(amount));
};


 